<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                    <sidebar></sidebar>
                </el-aside>
                <el-main>
                    <headSide :isShow="isShow"  @onWithdrawal="goRawal()" @release="onRelease()"></headSide>
                    <div class="mt-30">
                        <!--资料收入-->
                        <div>
                            <contTitle :obj="obj" :contTitle="contTitle1"></contTitle>
                            <div class="table">
                              <el-table :data="tableData" v-loading="listLoading"
                                :header-cell-style="headClass"
                                stripe
                                fit
                                style="width:100%; font-size:12px;">
                                <el-table-column  :show-overflow-tooltip="true" align="center" prop="goodsName" label="资料标题">
                                </el-table-column>
                                <el-table-column align="center" prop="amount"  label="结算金额（￥）">
                                  <template  slot-scope="scope">
                                    <span class="gren" v-if="scope.row.incomeUserid == id ">{{ '+' + scope.row.amount}}</span>
                                    <span v-else>{{scope.row.amount}}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column :show-overflow-tooltip="true" align="center" prop="transDate" label="下载时间" >
                                </el-table-column>
                                <el-table-column align="center" prop="userName" label="下载用户">
                                </el-table-column>
                             </el-table>
                         </div>
						    <!--分页-->
						   <Pagination v-show="total>0"   :total="total"  :page.sync="measQuery.curPage" :limit.sync="measQuery.limit" @pageChange="measPage" ></Pagination>
                        </div>
                        <!--提问收入-->
                        <div class="mt-30">
                          <contTitle :obj="obj" :contTitle="contTitle2"></contTitle>
                            <div class="table">
                              <el-table :data="tableData2" v-loading="loading"
                                :header-cell-style="headClass"
                                stripe
                                fit
                                style="width:100%;font-size:12px;">
                                <el-table-column  align="center" :show-overflow-tooltip="true"  prop="questioner" label="提问人" >
                                </el-table-column>
                                <el-table-column align="center" prop="amount"  label="提问金额（￥）" >
                                   <template  slot-scope="scope">
                                    <span class="gren" v-if="scope.row.incomeUserid == id ">{{ '+' + scope.row.amount}}</span>
                                    <span v-else>{{scope.row.amount}}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column :show-overflow-tooltip="true" align="center" prop="createDate" label="提问时间" >
                                </el-table-column>
                                <el-table-column align="center" prop="questionStatusStr" label="回答状态"></el-table-column>
                                <el-table-column align="center" prop="status" label="是否到账">
                                    <template slot-scope="scope">
                                        <span class="gren" v-if="scope.row.status =='1' && scope.row.status  ">已到账</span>
                                        <span class="yes" v-else >未到账</span>
                                    </template>
                                </el-table-column>
                              </el-table>
                           <!--分页-->
						   <Pagination v-show="totalInfo>0"   :total="totalInfo"  :page.sync="putQuery.curPage" :limit.sync="putQuery.limit" @pageChange="questionsPage" ></Pagination>
                            </div>
                        </div>
                        <!--提现收入-->
                        <div style="margin-top:100px;">
                          <contTitle :obj="obj" :contTitle="contTitle3"></contTitle>
                             <div class="table">
                                <el-table :data="tableData3" v-loading="loadings"
								    :header-cell-style="headClass"
                                    stripe
                                    fit
                                    style="width:100%;font-size:12px;">
                                    <el-table-column  align="center"   prop="userName" label="提现用户" >
                                    <template slot-scope="scope">
                                        <span>{{JSON.parse(scope.row.cashoutinfo).name }}</span>
                                    </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="amount"  label="提现金额（￥）" >
                                    </el-table-column>
                                    <el-table-column :show-overflow-tooltip="true" align="center" prop="transDate" label="提现时间" >
                                    </el-table-column>
                                    <el-table-column  align="center" prop="status" label="提现状态" >
                                        <template slot-scope="scope">
										                        <span  v-if="scope.row.status =='3'">待提现</span>
                                           <span class="gren" v-if="scope.row.status =='4'">提现成功</span>
                                           <span  class="yes" v-if="scope.row.status =='5'">提现失败</span>					   
                                        </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="receiveTypeStr" label="收款账户类型">
                                    <template slot-scope="scope">
                                        <span  v-if="JSON.parse(scope.row.cashoutinfo).alipayNumbe">{{JSON.parse(scope.row.cashoutinfo).alipayNumbe !=''?'支付宝':''}}</span>
                                      <span  v-if="JSON.parse(scope.row.cashoutinfo).weChatNumber" >{{JSON.parse(scope.row.cashoutinfo).weChatNumber !=''?'微信':''}}</span>
                                      <span  v-if="JSON.parse(scope.row.cashoutinfo).accountNumber">{{JSON.parse(scope.row.cashoutinfo).accountNumber !=''?'银行卡':''}}</span>
                                    </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="receiveAccount" label="收款账户">
                                    <template slot-scope="scope">
                                        <span v-if="JSON.parse(scope.row.cashoutinfo).alipayNumbe">{{JSON.parse(scope.row.cashoutinfo).alipayNumbe !=''?JSON.parse(scope.row.cashoutinfo).alipayNumbe:''}}</span>
                                      <span v-if="JSON.parse(scope.row.cashoutinfo).weChatNumber">{{JSON.parse(scope.row.cashoutinfo).weChatNumber !=''?JSON.parse(scope.row.cashoutinfo).weChatNumber:''}}</span>
                                      <span v-if="JSON.parse(scope.row.cashoutinfo).accountNumber">{{JSON.parse(scope.row.cashoutinfo).accountNumber !=''?JSON.parse(scope.row.cashoutinfo).accountNumber:''}}</span>
                                    </template>
                                    </el-table-column>
                                </el-table>                               
                             </div>
						          	<!--分页-->
						     <Pagination v-show="totals>0"  :total="totals"  :page.sync="withdQuery.curPage" :limit.sync="withdQuery.limit" @pageChange="pageChange" ></Pagination>
                        </div>
                    </div>

                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {incomeList,cashoutlist} from "@/api/coment"
import {queryExpertIncomeList} from "@/api/expert"
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import Pagination from '../../components/Pagination'
export default {
  components:{
      sidebar,headSide,commBanner,titleHead,contTitle,Pagination
  },
  data(){
      return{
        obj:{
            title:'我的收入',
            isShow:false,
            roleType:2,
            personalType:9,
            hide:false
        },
        isShow:true,
        contTitle1:'资料收入明细',
        contTitle2:'提问收入明细',
        contTitle3:'提现明细',
        headTitle:'我的收入',
        tableData:[], //资料收入
        tableData2:[],//提问收入
        tableData3:[],//提现明细
        measQuery:{ //资料
          curPage:1,
          limit:5,
		  goodstypes:1
        },
		putQuery:{ // 提问
		  curPage:1,
		  limit:5,
		},
		withdQuery:{ //提现
		  curPage:1,
		  limit:5,
		  goodstypes:1
		},
        total:0,//资料
        totals:0,///提现
        totalInfo:0,//收入
        listLoading:true,
        loading:true,
        loadings:true,
        sum:{},
        id:''
      }
  },
  created(){
      this.getIncomeList(); //资料收入
      this.getCashoutlist();//体现明细
      this.getQueryExpertIncomeList(); //提问收入
      this.obj.roleType = this.$store.state.user.userInfo.type;
      this.id = this.$store.state.user.userInfo.data.userId;
  },
  methods:{
      //修改表头样式
      headClass(){
         return 'background:#FF7402;text-align:center;color:white;'
      },
      tableRowClassName({row, rowIndex}){
         if(rowIndex ===1){

         }
      },
      //提现
      goRawal() {
        this.$router.push("/withdrawal");
      },
        //收入
      getIncomeList(){
         this.listLoading = true;
         incomeList(this.measQuery).then((res)=>{
             if(res.code ==0){
                 this.tableData = res.page.list;
                 this.total = res.page.totalCount;
             }
            this.listLoading = false;
         }).catch((err)=>{})
      },
      //体现明细
      getCashoutlist(){
         this.loading = true;
         cashoutlist(this.withdQuery).then((res)=>{
             if(res.code ==0){
                 this.tableData3 = res.page.list;
                 this.totals = res.page.totalCount;
             }
           this.loading = false;
         }).catch((err)=>{});
      },
      //提问收入明细
      getQueryExpertIncomeList(){
        this.loadings = true;
         queryExpertIncomeList(this.putQuery).then((res)=>{
             if(res.code == 0){
                this.tableData2 = res.page.list;
                this.totalInfo = res.page.totalCount;
             }
           this.loadings = false;
         }).catch((err)=>{});
      },

	  //资料收入分页
	  measPage(item){
		 this.measQuery['curPage'] = item.page;
		 this.measQuery['limit'] = item.limit; 
		 this.getIncomeList();
	  },
	  //提问收入分页
	  questionsPage(item){
		 this.putQuery['curPage'] = item.page;
		 this.putQuery['limit'] = item.limit; 
		 this.getQueryExpertIncomeList()
	  }, 
	  //提现分页
	  pageChange(item){
	    this.withdQuery['curPage'] = item.page;
	    this.withdQuery['limit'] = item.limit;
	    this.getCashoutlist();
	  },
    //发布需求
    onRelease(){
      this.$router.push('/demand')
    },
     //合并金额
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = '共计';
        return;
      }
      const values = data.map(item => Number(item[column.property]));
      if (!values.every(value => isNaN(value))) {
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        sums[index] += ' 元';
      }
    });
        return sums;
    }
  },
}
</script>
<style scoped>
/* .el-aside{
    height: 900px;
} */
.cont_text{
  margin-left: 12px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.table{
    margin-top: 20px;
	max-height: 300px;
}
.el-table .warning-row {
    background: oldlace;
}

 /*  斑马纹表格背景 */
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
     background:#FFF8F2;
}
.el-pagination{
   margin-top: 40px;
}

.gren{
  color: #56c451;
}
.yes{
  color: #ef9c9a;
}
</style>



// WEBPACK FOOTER //
// src/view/expert/expert_income.vue